namespace Gamification.Gamification {
    export class ChecklistCheckColumns {
        static columnsKey = 'Gamification.Checklist2Editor';
    }
}
